import { useShallow } from "zustand/react/shallow"
import { formatTableValidations } from "utilities/registryValidations"

// context
import useAppState from "context/hooks/useAppState"
import useAuthoringValidationsStore from "../stores/useAuthoringValidationsStore"
import useAuthoringViewStore from "../stores/useAuthoringViewStore"
import { AUTHORING_TASKS } from "constants/tasks.js"

// apis
import { usePostRegistryValidations } from "api/hooks/studies/useAuthoringApi"

const useAuthoringValidationActions = (authoringId) => {
  const { openToastNotification, setPollingTaskId, setTaskType, pollingCallbackRef } = useAppState()
  const postRegistryValidations = usePostRegistryValidations(authoringId)

  const { setValidations, setRegistryValidations, setSitesValidations, setResultsTableValidations } =
    useAuthoringValidationsStore(
      useShallow((state) => ({
        setValidations: state.setValidations,
        setRegistryValidations: state.setRegistryValidations,
        setSitesValidations: state.setSitesValidations,
        setResultsTableValidations: state.setResultsTableValidations,
      }))
    )

  const { setPanelView, setShowPanel } = useAuthoringViewStore(
    useShallow((state) => ({
      setShowPanel: state.setShowPanel,
      setPanelView: state.setPanelView,
    }))
  )

  const clearValidations = () => {
    setValidations(null)
    setSitesValidations([])
    setRegistryValidations(null)
    setResultsTableValidations(null)
  }

  // REGISTRY VALIDATIONS
  const onRegistryValidate = async (options) => {
    openToastNotification("info", "Loading", "Retrieving validations in progress")

    const callback = async (data) => {
      if (data?.validations) {
        let validations = []

        if (data?.validations) validations = [...data.validations]

        // create lookup table for validation messages
        if (validations.length > 0) {
          let validationMsgs = null
          data.validations.forEach((msgItem) => {
            if (!validationMsgs) validationMsgs = {}
            if (!validationMsgs[`root_${msgItem.field_key}`]) {
              validationMsgs[`root_${msgItem.field_key}`] = []
            }
            validationMsgs[`root_${msgItem.field_key}`].push(msgItem)
          })
          if (validationMsgs) setRegistryValidations(validationMsgs)
        }

        if (data) {
          setValidations(data)
          let tableValidations = formatTableValidations(data.validations)
          setResultsTableValidations(tableValidations)
        }

        // validation messages that cannot be mapped to fields for side panel "Validations" tab
        if (data?.unmapped_validations) {
          let sitesValidations = []
          data?.unmapped_validations.forEach((validation) => {
            if (validation.hasOwnProperty("site_db_id")) {
              sitesValidations.push(validation)
            }
          })

          setSitesValidations(sitesValidations)
        }
        setShowPanel(true)
        setPanelView("validations")
        // openToastNotification("success", "Success", "Successfully retrieved validation messages")
      }
    }

    postRegistryValidations(
      { body: options },
      {
        onSuccess: async ({ data }) => {
          pollingCallbackRef.current = callback
          setPollingTaskId(data?.task_id)
          setTaskType(AUTHORING_TASKS.validation)
        },
      }
    )
  }

  return {
    clearValidations,
    onRegistryValidate,
  }
}

export default useAuthoringValidationActions
